/**
 * 将传入的函数变成带缓存的函数
 * @param func 函数
 */
export function cacheFunc<T extends (...args: any[]) => any>(func: T) {
  let result: ReturnType<T> | undefined;
  let isRequested = false;
  const cacheFunc = (...args: Parameters<T>): ReturnType<T> => {
    if (isRequested) return result!;
    result = func(...args);
    isRequested = true;
    return result!;
  };
  cacheFunc.clearCache = () => {
    result = undefined;
    isRequested = false;
  };
  return cacheFunc;
}
